module.exports = __webpack_public_path__ + "img/Left Locker.14a181f5.png";